"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKSPACE_SEARCH_ADVANCED_EVENT = exports.SEARCH_PARTITION_MAX_REQUESTED_MAILS = exports.SEARCH_PARTITION_MAX_REQUESTED_DOCS = void 0;
exports.searchPartitionDigestSource = searchPartitionDigestSource;
exports.isSearchPartitionExclusion = isSearchPartitionExclusion;
exports.withoutSearchPartitions = withoutSearchPartitions;
const partition_index_1 = require("./partition-index");
/** Pages whose content one partition page request may ask for. */
exports.SEARCH_PARTITION_MAX_REQUESTED_DOCS = 100;
/** Mails whose content one partition page request may ask for. */
exports.SEARCH_PARTITION_MAX_REQUESTED_MAILS = 100;
const byText = (left, right) => left < right ? -1 : left > right ? 1 : 0;
/**
 * The text a search partition digest hashes: one line per page,
 * `docId<TAB>contentVersion<TAB>fileTextVersion`, ordered by docId, an
 * unrecorded version as empty text; then one line per mail,
 * `mail<TAB>messageId<TAB>contentHash`, ordered by messageId. A partition
 * without mails hashes its page lines only. Server and clients hash the same
 * text, so equal digests mean equal pages and mails in equal versions.
 */
function searchPartitionDigestSource(entries, mails = []) {
    return [
        ...[...entries]
            .sort((left, right) => byText(left.docId, right.docId))
            .map(entry => `${entry.docId}\t${entry.contentVersion ?? ''}\t${entry.fileTextVersion ?? ''}`),
        ...[...mails]
            .sort((left, right) => byText(left.messageId, right.messageId))
            .map(mail => `mail\t${mail.messageId}\t${mail.contentHash}`),
    ].join('\n');
}
/**
 * Whether `value` is a valid list of search partitions a client answers
 * from its own index: distinct partition indexes, never page ids.
 */
function isSearchPartitionExclusion(value) {
    if (!Array.isArray(value) ||
        value.length > partition_index_1.PERMISSION_SNAPSHOT_PARTITION_COUNT)
        return false;
    const seen = new Set();
    for (const partitionIndex of value) {
        if (!Number.isInteger(partitionIndex) ||
            partitionIndex < 0 ||
            partitionIndex >= partition_index_1.PERMISSION_SNAPSHOT_PARTITION_COUNT ||
            seen.has(partitionIndex))
            return false;
        seen.add(partitionIndex);
    }
    return true;
}
/** The pages left for a server search after the client's own partitions. */
function withoutSearchPartitions(docIds, excluded) {
    if (excluded.length === 0)
        return [...docIds];
    const skip = new Set(excluded);
    return docIds.filter(docId => !skip.has((0, partition_index_1.permissionSnapshotPartitionIndex)('doc', docId)));
}
/** Socket event: the search index of a readable page holds a new version. */
exports.WORKSPACE_SEARCH_ADVANCED_EVENT = 'workspace:search-advanced';
//# sourceMappingURL=search-partition.js.map